import { Injectable } from '@angular/core';
import {ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private toastr: ToastrService) {}

  public toastInfo(message: string) {
    this.showToastr('info', message);
  }

  public toastSuccess(message: string) {
    this.showToastr('success', message);
  }

  public toastWarning(message: string) {
    this.showToastr('warning', message);
  }

  public toastError(message: string) {
    this.showToastr('danger', message);
  }

  private showToastr(type: string, message: string) {
    this.toastr.info('<span class="tim-icons icon-bell-55" [data-notify]="icon"></span> ' + message, '', {
      disableTimeOut: true,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-" + type + " alert-with-icon",
      positionClass: 'toast-top-right'
    });
  }
}
